import React, { useEffect, useState } from 'react';

export type Classnames = Array<string> | string;

export const useBemBlockClassNames = (blockClassnames: Classnames) => {
  const [classes, setClasses] = useState('');

  useEffect(() => {
    if (Array.isArray(blockClassnames)) {
      if (blockClassnames.length) {
        setClasses(blockClassnames.join(' '));
      } else {
        setClasses('');
      }
    } else if (blockClassnames.length) {
      setClasses(blockClassnames);
    } else {
      setClasses('');
    }
  }, [blockClassnames]);

  return classes;
};

export const useBemElementClassNames = (
  blockClassnames: Classnames,
  element: string,
) => {
  const [classes, setClasses] = useState('');

  useEffect(() => {
    if (Array.isArray(blockClassnames)) {
      if (blockClassnames.length) {
        setClasses(
          blockClassnames
            .map((blockClass: string) => `${blockClass}--${element}`)
            .join(' '),
        );
      } else {
        setClasses('');
      }
    } else if (blockClassnames.length) {
      const blockClassnamesAsArray = blockClassnames.split(' ');
      setClasses(
        blockClassnamesAsArray
          .map((blockClassname) => `${blockClassname}--${element}`)
          .join(' '),
      );
    } else {
      setClasses('');
    }
  }, [blockClassnames, element]);

  return classes;
};

export const useBemModifierClassNames = (
  classnames: Classnames,
  modifier: string,
) => {
  const [classes, setClasses] = useState('');

  useEffect(() => {
    if (Array.isArray(classnames)) {
      if (classnames.length) {
        setClasses(
          classnames
            .map((blockClass: string) => `${blockClass}__${modifier}`)
            .join(' '),
        );
      } else {
        setClasses('');
      }
    } else if (classnames.length) {
      const classnamesAsArray = classnames.split(' ');
      setClasses(
        classnamesAsArray
          .map((classname) => `${classname}__${modifier}`)
          .join(' '),
      );
    } else {
      setClasses('');
    }
  }, [classnames, modifier]);

  return classes;
};
